export default __webpack_public_path__ + "static/bca-d9c2cd673c1390a5dd2cb59bdf8699ed.png";